import { TApiResponse } from '@/common/types/response';

import { TActiveAgreementsState } from './types';

export function setListOfAgreements(
  state: TActiveAgreementsState,
  res: TApiResponse<TActiveAgreementsState['listOfAgreements']>,
) {
  state.listOfAgreements = res.data;
}

export function setAgreementsCount(
  state: TActiveAgreementsState,
  res: TApiResponse<TActiveAgreementsState['agreementsCount']>,
) {
  state.agreementsCount = res.data;
}

export function setIsLoadingCount(state: TActiveAgreementsState, isLoading: boolean) {
  state.isLoadingCount = isLoading;
}

export function setAgreementTypes(
  state: TActiveAgreementsState,
  res: TApiResponse<TActiveAgreementsState['agreementTypes']>,
) {
  state.agreementTypes = res.data;
}
